import { Checkbox, CheckboxProps } from "antd";
import React from "react";
import styles from "./index.module.scss";
import { div } from "three/webgpu";

interface Props extends CheckboxProps {}

const BlessCheckbox = ({ ...checkbox }: Props) => {
  return (
    <div className={styles.checkboxWrapper}>
      <Checkbox {...checkbox} className={styles.check} />
    </div>
  );
};

export default BlessCheckbox;
